export default import.meta.ROLLDOWN_FILE_URL_3ei3$gk_tR5H6RNSALn3SQ